import React from "react";
import ImageGallery from "../components/ImageGallery";

function ConcertPage() {
  return <ImageGallery category="concert" />;
}

export default ConcertPage;
